<template>
	<div class="cbs-dropdown-control">
		<legend class="flex justify-between items-center">
			<div>{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:</div>
			<cbs-hint
				v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<v-select
			class="w-full"
			label="content"
			v-model="localValue.value"
			v-validate="!localValue.is_optional ? 'required' : ''"
			:reduce="option => option.id"
			:data-vv-as="localValue.title"
			:options="localOptionsAttributeValue"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Choose')} ${localValue.title.toLowerCase()}`"
		>
			<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
		</v-select>
		<span class="text-danger text-sm" v-if="!localValue.is_optional">{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	name: "DropdownControl",
	inject: ["parentValidator"],
	components: {
		vSelect,
		CbsHint
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localOptionsAttributeValue() {
			return this.localAttributesValue.options || [];
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style></style>
